import Translate from './Translate';

export { Translate };
